import { Box } from '@chakra-ui/react';
import ImageShimmer from '../ImageShimmer/ImageShimmer';

export default function StatWithIcon({
  stat,
}: {
  stat: {
    image: {
      sourceUrl: string;
      altText: string;
    };
    item: string;
    text: string;
  };
}) {
  return (
    <Box textAlign="center">
      <Box w="16" h="16" display="inline-flex" alignItems="center" justifyContent="center">
        {stat.image && (
          <ImageShimmer
            src={stat.image.sourceUrl}
            alt={stat.image.altText}
            width="64"
            height="64"
            style={{ objectFit: 'contain' }}
            layout="intrinsic"
          />
        )}
      </Box>
      <Box fontSize="4.5rem" lineHeight="4.5rem" fontWeight="bold" my="6">
        {stat.item}
      </Box>
      <Box fontSize="1.5rem" lineHeight="7" fontWeight="semibold">
        {stat.text}
      </Box>
    </Box>
  );
}
